var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-chart"},[_c('apexchart',{attrs:{"height":400,"type":"area","options":_vm.chart.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }